import axios from 'axios';

import type { Settings } from '../domain';

export const API_ROOT = '/api/v1/settings';

export async function fetchSettings(): Promise<Settings> {
  const response = await axios.get<Settings>(API_ROOT);
  return response.data;
}
